import * as React from 'react';
import { jsx, css } from '@emotion/react';
import { LoanSvg } from '../assets/Loan.svg';
import { InsuranceSvg } from '../assets/Insurance.svg';
import { FollowUpSvg } from '../assets/FollowUp.svg';

export const BENEFIT_LIST = [
  {
    id: 1,
    keyName: 'loan',
    iconElement: (<LoanSvg />),
    text: 'ローン有',
  },
  {
    id: 2,
    keyName: 'insurance',
    iconElement: (<InsuranceSvg />),
    text: '各種保険完備',
  },
  {
    id: 3,
    keyName: 'followUp',
    iconElement: (<FollowUpSvg />),
    text: 'アフターフォロー',
  },
];
